<template>
    <section class="prereg-wrap" :class="{'blur': currentStage === 'email' || currentStage === 'terms'}">
        <!-- logo -->
        <img src="../../assets/images/logo_small.png" class="logo" alt="logo">
        <!-- role -->
        <transition name="role">
            <img v-show="currentStage === 'email' || currentStage === 'terms'" src="../../assets/images/home/pre/role.png" class="role" alt="">
        </transition>
        
        <!-- 预约 -->
        <div class="pre-wrap" :class="{ 'zoomout': currentStage === 'email' || currentStage === 'terms' }">
            <!-- 提示语 -->
            <!-- <transition name="pretip">
                <p class="pre-tip" v-show="preTipShow">이미 사전 예약을 완료한 번호입니다.<br> CBT 신청을 원하실 경우 아래 버튼을 눌러 진행하여 주십시오.</p>
            </transition> -->
            <!-- 关闭按钮 -->
            <i class="iconfont iconguanbi pre-btn--close" v-show="currentStage === 'toemail'" @click="closeToEmail"></i>
            <i class="iconfont iconguanbi pre-btn--close" v-show="currentStage === 'email' || currentStage === 'terms'" @click="backOldStage"></i>
            <div class="pre-container" :class="currentStage">
                <!-- 手机号预约 -->
                <!-- <transition name="switch" mode="out-in"> -->
                    <div key="phone-stage" v-if="currentStage === 'phone' || currentStage === ''">
                        <!-- 选择渠道 -->
                        <div class="sel-channel-box">
                            <div class="sel-ios-box">
                                <div class="sel-checkbox" :class="{ 'active': channel === 'ios' }" @click="selChannel('ios')"></div>
                                <i class="ios"></i>
                                <span class="sel-text">App Store</span>
                            </div>
                            <div class="sel-google-box">
                                <div class="sel-checkbox" :class="{ 'active': channel === 'google' }" @click="selChannel('google')"></div>
                                <i class="google"></i>
                                <span class="sel-text">Google Play</span>
                            </div>
                        </div>
                        <!-- 输入电话号码 -->
                        <div class="phone-box">
                            <div class="phone-pre-num">010 -</div>
                            <div class="phone-content">
                                <input class="phone-content-input" v-model.number.trim="phoneNum" type="tel" placeholder="- 를 제외한 휴대폰 번호를 입력해주세요.">
                            </div>
                        </div>
                    </div>
                    <!-- 引导去申请邮件 -->
                    <div key="toemail-stage" v-if="currentStage === 'toemail'" >
                        <p class="toemail_tip">사전예약 신청 완료！</p>
                        <!-- <img src="../../assets/images/home/pre/toemail_btn.png" class="toemail_btn" @click="toEmail" alt=""> -->
                    </div>
                <!-- </transition> -->
                
                <!-- 申请邮箱 -->
                <template v-if="currentStage === 'email'">
                    <div class="email-cover" v-if="!shareStage">
                        <div class="email-title">
                            <img src="../../assets/images/home/pre/email_icon.png" class="email_icon" alt="">
                            <p class="email_tip">CBT 신청하기</p>
                        </div>
                        <p class="email-label">E-MAIL:</p>
                        <div class="email-content">
                            <input type="email" v-model.trim="email" class="email-input" placeholder="'구글 플레이 스토어'에 등록된 이메일 주소 입력">
                        </div>
                        <div class="code-wrap">
                            <div class="code-content">
                                <input type="text" class="code-input" placeholder="인증코드를 입력해 주세요" v-model.trim="code">
                            </div>
                            <div class="code-btn" @click="sendCode">
                                <span v-show="!waitCode_show">인증코드 발송</span> 
                                <span v-show="waitCode_show">{{ waitTime }}s 후 재발송 가능</span>
                            </div>
                        </div>
                        <div class="email-btn" @click="saveEmail">
                            확인
                        </div>
                        <div class="email-tip">
                            <p>※주의사항:</p>
                            <p>- 인증 코드 메일의 유효시간은 30분입니다.</p>
                            <p>- 인증 코드 메일이 오지 않는 경우에는 스팸 메일함을 확인 바랍니다.</p>
                            <p>- CBT 신청 후 당첨 여부는 입력하신 메일로 일괄 통지드립니다.</p>
                            <p>- CBT 관련 정보를 정상적으로 수령할 수 있도록, 반드시 사용 가능한 </p>
                            <p class="email-tip--indent">구글 플레이 스토어에 등록된 이메일 주소를 입력하여 주십시오.</p>
                            <p>- 당첨 확인 메일 발송 시 네이버 공식 카페를 통해서도 공지드리오니,</p>
                            <p class="email-tip--indent">빠른 소식 확인을 위해 카페 가입을 권장드립니다. </p>
                            <p class="email-tip--indent">(공식 카페: <a href="http://cafe.naver.com/arknightskor" target="_blank">http://cafe.naver.com/arknightskor </a>)</p>
                            <p> - CBT 참여 권한은 신청자 본인에 한해 사용 가능하며, 해당 정보 누출 시</p>
                            <p class="email-tip--indent">발생하는 피해에 대해 책임을 지지 않사오니, 주의 부탁드립니다.</p>
                            <p>- CBT는 Google Play Store를 통해 참여 가능합니다.</p>
                        </div>
                    </div>
                    <!-- 申请成功，sns分享 -->
                    <div class="share-sns-cover" v-if="shareStage">
                        <div class="share-title">
                            <img src="../../assets/images/home/pre/email_icon.png" class="share-icon" alt="">
                            <p class="share-tip">CBT 신청 완료</p>
                        </div>
                        <div class="share-text">
                            <p>※CBT관련 안내</p>
                            <p>- CBT 당첨 결과 발표는 공식 카페를 (<a href="http://cafe.naver.com/arknightskor" target="_blank">http://cafe.naver.com/arknightskor</a>) 통해 공지드리오니, 신속히 소식을 접하실 수 있도록 카페 가입을 권장드립니다.</p>
                            <p>- 당첨되신 경우, 입력하신 메일로 CBT관련 링크가 전송됩니다.</p>
                            <p>- 전송된 링크와 권한은 1인에 한해 사용가능하며, 해당 정보가 누출될 경우 발생하는 피해에 대해 YOSTAR는 책임지지 않습니다.</p>
                        </div>
                        <div class="sns-title">
                            <img src="../../assets/images/home/pre/sns_icon.png" class="share-icon" alt="">
                            <p class="share-tip">SNS 공유하기</p>
                        </div>
                        <div class="sns-btn-box">
                            <div class="sns-btn" v-for="(item, index) in shareList" :key="`sns-${index}`" @click="snsShare(item.name)">
                                <img :src="item.icon" class="sns-img" alt="">
                            </div>
                        </div>
                        <div class="share-text--bottom">
                            <p>※공유 이벤트 관련 안내</p>
                            <p>-위 아이콘을 클릭하면 해당 플랫폼에 사전예약 소식 공유가 가능하시며, 동시에 &lt;사전예약 소식 공유&gt; 이벤트 참여가 완료됩니다.</p>
                            <p>-단, 공유 시 반드시 ‘#명일방주#명일방주사전예약개시’ 해쉬태그를 추가해야 본 이벤트 참여로 간주됩니다.</p>
                        </div>
                    </div>
                </template>

                    <!-- 条款详细 -->
                    <template v-if="currentStage === 'terms'">
                        <div class="terms-cover">
                            <div class="terms-title">
                                <img src="../../assets/images/home/pre/terms_icon.png" class="terms-icon" alt="">
                                <p class="terms-tip">자세히 보기</p>
                            </div>
                            <div class="terms-detail">
                                <p>YOSTAR LIMITED는 사전예약을 완료하신 유저분께 아래와 같이 본인의 개인정보를 수집 및 이용하는 데 동의를 받고자 합니다.</p>
                                <p>1. 개인정보 수집 및 이용 목적</p>
                                <p>-&lt;명일방주&gt; 사전예약 이벤트 소식 안내, CBT개시 및 관련 소식 안내, 광고성, 정식 서비스 개시 안내 및 고지 사항 전달</p>
                                <p>2. 개인정보 수집 항목: 휴대전화번호, 구글 플레이 스토어에 등록된 이메일 주소 (CBT 참여 희망자에 한해)</p>
                                <p>3. 개인정보 보유 및 이용 기간: 동의일로부터 1년 경과 후 삭제</p>
                                <p>귀하는 위 개인정보 수집 및 이용에 대하여 거부하실 수 있으나, 거부 시 사전예약 및 관련 이벤트 참여, 정식 서비스 개시 안내 등의 정보를 받으실 수 없습니다.</p>
                                <p>개인정보 처리에 관한 보다 상세한 내용은 당사에서 고지한 ‘개인정보처리방침’을 통하여 확인해주시기 바랍니다.</p>
                                <p style="text-align:right"><a class="terms-a" target="_blank" href="/privacy">개인정보처리방침 바로가기</a></p>
                            </div>
                        </div>
                    </template>

                    <!-- 相关条款 -->
                    <div class="terms-box" v-if="currentStage === 'phone'">
                        <div class="terms-checkbox iconfont" :class="[{ 'active': agreeTerms || currentStage !== 'phone' }, { 'disable': currentStage !== 'phone' }]" @click="toggleAgree"></div>
                        <p class="terms-text">
                            <span :class="{ 'disable': currentStage !== 'phone' }">개인정보 수집이용 및 SMS 수신에 동의합니다.</span>
                            <a href="javascript: void(0);" @click="showTerms">자세히 보기</a>
                        </p>
                    </div>
                    <!-- cbt btn -->
                    <div v-if="currentStage === 'phone'" class="cbt-btn-wrap" :class="{ 'active': cbtBtnActive }" @click="savePhoneNum">
                        <img src="../../assets/images/home/pre/cbt_btn.png" class="cbt-btn-img" alt="">
                    </div>

                    <!-- tip -->
                    <!-- <p class="cbt-tip" v-if="currentStage === 'phone'"><mark class="cbt-tip-mark">CBT 신청 기간이 종료되었습니다.</mark>CBT 자격을 획득하신 분들께선 Google Play 환경에서만 테스트를 진행하실 수 있습니다.</p> -->
                    <p class="cbt-tip" v-if="currentStage === 'phone'"><mark class="cbt-tip-mark">Google play store</mark> 사전예약이 오픈 되었습니다.</p>
                    <p class="cbt-tip cbt-tip--toemail" v-if="currentStage === 'toemail'">
                        <a href="https://apps.apple.com/kr/app/id1473903308?mt=8 " target="_blank" class="pre-ios">
                            <img src="../../assets/images/home/top/pre_ios.png" alt="">
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.YoStarKR.Arknights" target="_blank" class="pre-google">
                            <img src="../../assets/images/home/top/pre_google.png" alt="">
                        </a>
                    </p>
            </div>
        </div>
        <!-- toemail 底层遮罩 -->
        <div class="toemail-mask" :class="{'show': currentStage === 'toemail' }"></div>
    </section>
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
    name: "Prereg",

    components: {

    },
    data: () => ({
        channel: '',                // 选择的渠道
        phoneNum: '',               // 输入的电话号码
        email: '',                  // 输入的邮箱
        agreeTerms: false,          // 是否同意条款
        cbtBtnActive: false,        // cbt按钮是否激活
        currentStage: 'phone',      // 当前预约阶段（phone: 手机号码预约， toemail: 引导去预约邮箱界面， email: 申请邮箱, terms: 条款详细）
        oldStage: '',               // 之前阶段
        shareStage: false,           // 邮件申请成功，分享阶段

        shareList: [                // 分享按钮
            {
                name: 'fb',
                icon: require("../../assets/images/home/pre/share_fb.png"),
            },
            {
                name: 'tw',
                icon: require("../../assets/images/home/pre/share_tw.png"),
            },
            {
                name: 'kakao',
                icon: require("../../assets/images/home/pre/share_kakao.png"),
            }
        ],
        waitCode_show: false,
        waitTime: 60,
        waitTimer: null,
        code: "",        // 邮件验证码

        preTipShow: false,
        preTipTimer: null,
    }),
    created() {
        if(process.env.VUE_APP_ENV !== 'online' && this.$route.query.num) {
            this.$store.commit('Pre/SET_PRE_NUM', this.$route.query.num)
        } else {
            this.getCurrentPreregNum()
        }
    },
    mounted() {
    },
    watch: {
        waitCode_show(val) {
            if(val) {
                // 开启定时器
                this.waitTimer = setInterval(() => {
                    this.waitTime = this.waitTime - 1;
                    if(this.waitTime <= 0) {
                        // 清除
                        clearInterval(this.waitTimer);
                        this.waitTimer = null;
                        this.waitTime = 60;
                        this.waitCode_show = false;
                    }
                }, 1000)
            } else {
                clearInterval(this.waitTimer)
                this.waitTimer = null
                this.waitTime = 60
            }
        },
        phoneNum(val) {
            if(val > 100000000) {
                this.phoneNum = parseInt(val.toString().slice(0,8))
            }
        }
    },
    computed: {
        checkoutPhoneNum() {
            // 检查电话号码格式（去除010，8位）
            return /^\d{8}$/.test(this.phoneNum)
        },
        completePhoneNum() {
            // 完整的电话号码（前面加上010）
            return `010${this.phoneNum}`
        },
        ...mapState({
            FINGERPRINT: state => state.FINGERPRINT
        })
    },
    methods: {
        selChannel(channel) {
            this.channel = channel
        },
        toggleAgree() {         
            if(this.cbtBtnActive) {
                return false;
            }
            this.agreeTerms = !this.agreeTerms
        },
        showTerms() {           // 显示条款文本
            // 保存之前阶段，用于返回
            if(this.currentStage === 'terms') {
                return
            }
            this.oldStage = this.currentStage
            this.currentStage = "terms"
        },
        checkoutSavePhone() {
            // 检查保持电话号码所有条件
            if(!this.channel) {
                alert("스토어를 선택하여 주십시오.")
                return false
            } else if(!this.checkoutPhoneNum) {
                alert("정확한 휴대폰 번호를 입력하여 주십시오.")
                return false
            } else if(!this.agreeTerms) {
                alert("관련 약관에 동의하신 후 진행 가능합니다.")
                return false
            } else {
                return true
            }
        },
        checkoutEmail() {       // 邮箱验证
            const reg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
            if(this.email == '') {
                alert("구글 플레이에 등록된 접속 메일 주소를 입력하여 주십시오.")
                return false;
            } else if(!reg.test(this.email)) {
                alert("정확한 메일 주소를 입력하여 주십시오.")
                return false;
            } else {
                return true;
            }
        },
        savePhoneNum() {        // 保存手机号
            if(!this.checkoutSavePhone()) {
                return false
            } else if(this.cbtBtnActive) {
                // 保存手机号码按钮已经激活过
                return false
            } else {
                // 开始保存
                this.axios.post("/prereg/savetel", {
                    "telephone": this.completePhoneNum,
                    "channel": this.channel,
                    "_f": this.FINGERPRINT,
                    "_o": this.$utils.getOrigin(this)
                }).then(v => {
                    console.log(v)
                    if(v.retcode === 0) {
                        // 保存手机号码成功
                        this.cbtBtnActive = true
                        this.currentStage = 'toemail'
                        // fq
                        fbq('track', 'CompleteRegistration');
                        // ga
                        gtag('event', 'registration_complete', {
                            'event_category' : 'engagement',
                            'event_label' : 'not set'
                        });
                        gtag('event', 'conversion', {'send_to': 'AW-693934217/yvWzCL7f8LQBEImx8soC'});
                        // smartposting2
                        smp_rev('reserve');
                    } else if(v.retcode === -2002) {
                        // 已经预约过
                        alert("사전예약 및 CBT 신청이 완료된 휴대폰 번호입니다.")
                    } else if(v.retcode === -2003) {
                        // 已经预约手机号，没有预约邮件
                        this.cbtBtnActive = true
                        this.currentStage = 'toemail'
                        this.showPreTip()
                        setTimeout(() => {
                            alert("사전예약 신청이 완료된 휴대폰 번호입니다. ")
                        }, 500)
                        
                    } else if(v.retcode === -2001) {
                        // 渠道不同
                        if(confirm("이미 스토어를 선택하셨습니다. 변경하시겠습니까?")) {
                            this.changeChannel(this.completePhoneNum, this.channel)
                        }
                    }
                    // 保存号码到 sessionStorage
                    sessionStorage.setItem("tel", this.completePhoneNum)
                    // 获取当前预约人数
                    this.getCurrentPreregNum()
                    
                }).catch(e => {
                    console.log(e)
                    alert("unexpected error!")
                })
            }
        },
        toEmail() {
            this.oldStage = 'phone'
            this.currentStage = 'email'
        },
        backOldStage() {        // 返回之前阶段
            this.currentStage = this.oldStage
            this.oldStage = 'phone'
            this.shareStage = false
            this.email = ""
            this.code = ""
            this.waitCode_show = false

            if(this.currentStage === 'phone') {
                this.cbtBtnActive = false
            }
        },
        closeToEmail() {
            this.currentStage = 'phone'
            this.cbtBtnActive = false
            
            if(this.preTipShow) {
                this.hidePreTip()
            }
        },
        saveEmail() {       // 保存邮箱
            if(!this.checkoutEmail() ) {
                return false
            }
            if(!this.code) {
                alert("메일을 통해 전송된 인증 코드를 입력하여 주십시오.")
                return false
            }
            // 开始保存
            this.axios.post("/prereg/saveemail", {
                telephone: this.completePhoneNum,
                email: this.email,
                code: this.code
            }).then(v => {
                console.log(v)
                if(v.retcode === 0) {
                    // 验证并保存成功
                    alert("CBT 신청이 완료되었습니다.")
                    this.shareStage = true
                } else if(v.retcode === -2001) {
                    // 无效code
                    alert("입력 코드가 정확하지 않습니다. 정확한 코드를 입력하여 주십시오.")
                } else if(v.retcode === -2002) {
                    // 验证失败
                    alert("코드 인증 실패. 잠시 후 다시 시도하여 주십시오.")
                } else if(v.retcode === -2003) {
                    // 保存邮件失败
                    alert("CBT 신청 실패. 잠시 후 다시 시도하여 주십시오.")
                }
            }).catch(e => {
                console.log(e)
                // unexpected error!
                alert("unexpected error!")
            })
        },
        changeChannel(telephone, channel) {     // 更换渠道
            this.axios.post("/prereg/changechannel", {
                telephone,
                channel
            }).then(v => {
                console.log(v)
                if(v.retcode === 0) {
                    // 更换渠道成功
                    this.cbtBtnActive = true
                    this.currentStage = 'toemail'
                } else if(v.retcode === -2001) {
                    // 更换渠道失败
                    alert("스토어 변경 실패. 다시 시도하여 주십시오.")
                }
            }).catch(e => {
                console.log(e)
            })
        },
        sendCode() {
            if(this.waitCode_show) {
                return false
            }
            if(!this.checkoutEmail()) {
                return false
            }
            this.axios.post('/prereg/sendcode', {
                "email": this.email
            }).then(v => {
                console.log(v)
                if(v.retcode === 0) {
                    // 发生验证码成功
                    this.waitCode_show = true
                } else if(v.retcode === -2001) {
                    alert("인증 코드는 1분간 최대 1회만 요청 가능합니다.")
                }
            }).catch(e => {
                console.log(e)
                alert("unexpected error!")
            })
        },
        snsShare(channel) {
            this.axios.post("/prereg/snsshare", {
                "telephone": this.completePhoneNum,
                "plat": channel
            }).then(v => {
                console.log(v)
            }).catch(e => {
                console.log(e)
            })
            this.$utils.snsShare(channel)
        },
        getCurrentPreregNum() {     // 获取当前预约人数
            this.axios.get("/prereg/perreg_num").then(v => {
                if(v.retcode === 0) {
                    this.$store.commit('Pre/SET_PRE_NUM', v.data.num)
                }
            }).catch(e => {
                console.log(e)
            })
        },
        showPreTip() {
            this.preTipShow = true
            this.preTipTimer = setTimeout(() => {
                this.preTipShow = false
            }, 3000)
        },
        hidePreTip() {
            this.preTipShow = false
            clearTimeout(this.preTipTimer)
            this.preTipTimer = null
        }
    },
};
</script>

<style lang="scss" scoped>
.prereg-wrap {
    background: #000 url("../../assets/images/home/pre/bg.png") no-repeat;
    background-size: cover;
    background-position: center center; 
    position: relative;

    &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: #000 url("../../assets/images/home/pre/bg.png") no-repeat;
        background-size: cover;
        background-position: center center; 
        filter: blur(10px);
        z-index: 1;
        opacity: 0;
        transition: all .3s ease-in-out;
    }

    &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 2;
        background: url("../../assets/images/home/pre/email_texture.png");
    }

    .logo {
        position: absolute;
        width: pxTorem(208px);
        right: pxTorem(75px);
        top: pxTorem(76px);
        z-index: 3;
        transition: all .3s ease-in-out;
    }
    .role {
        position: absolute;
        z-index: 3;
        bottom: 0;
        left: 0;
        height: 100%;
    }
    // 模糊
    &.blur {
        &::before {
            opacity: 1;
        }
        &::after {
            background: rgba(0, 0, 0, 0.9);
        }
        .logo {
            filter: blur(10px);
        }
    }
    
    /* 预约 */
    .pre-wrap {
        position: absolute;
        z-index: 3;
        bottom: pxTorem(42px);
        left: 50%;
        transform: translateX(-50%);
        transition: all .3s ease-in-out;

        .pre-tip {
            width: 80%;
            left: 50%;
            transform: translateX(-50%);
            position: absolute;
            bottom: 110%;
            text-align: center;
            background: #3e3e3e;
            color: #fff;
            font-size: pxTorem(16px);
            border-radius: 5px;
            box-sizing: border-box;
            padding: pxTorem(5px) pxTorem(10px);
        }

        // 界面整体缩小
        &.zoomout {
            bottom: 45%;
            transform: translate(-50%, 50%) scale(1);
        }

        /* 关闭按钮 */
        .pre-btn--close {
            color: #ffd300;
            font-size: pxTorem(48px);
            position: absolute;
            right: 0%;
            bottom: 100%;
            z-index: 5;
            cursor: pointer;
        }
    }
    .pre-container {
        position: relative;
        width: pxTorem(696px);
        min-height: pxTorem(350px);
        background: rgba(67, 67, 67, .7);
        top: 0;
        left: 0;
        padding: pxTorem(42px) pxTorem(54px) pxTorem(34px);
        box-sizing: border-box;
        border-radius: 15px;
        transition: all .3s ease-in-out;
        // transition-delay: 0.5s;

        @mixin channel{
            background:url("../../assets/images/home/pre/channel.png") no-repeat; 
            background-size: pxTorem(47px) pxTorem(27px);
        }

        &.toemail {
            background: linear-gradient(to bottom, rgba(62, 62, 62, 1), #121313 80%,  #121313);

            .toemail_btn {
                margin-bottom: pxTorem(35px) !important;
            }
        }
        &.email {
            padding: pxTorem(17px) 0 pxTorem(34px);
            width: pxTorem(588px);
            overflow: hidden;
            background: transparent;

            &::before {
                content: "";
                display: block;
                border-radius: 15px;
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background: linear-gradient(to bottom, rgba(255, 255, 255, .5), rgba(255, 255, 255, 0) 60%, rgba(255, 255, 255, 0));
                transform: scale(1.1);
                filter: blur(15px);
                z-index: -1;
            }
            &::after {
                content: "";
                display: block;
                border-radius: 15px;
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                z-index: -2;
                background: url("../../assets/images/home/pre/email_bg.png") no-repeat;
                background-size: 100%;
                background-position: 100% 5%;
                opacity: 0.5;
            }
        }
        &.terms {
            padding: pxTorem(17px) 0 pxTorem(34px);
            width: pxTorem(588px);
            overflow: hidden;
            background: transparent;

            &::before {
                content: "";
                display: block;
                border-radius: 15px;
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background: linear-gradient(to bottom, rgba(255, 255, 255, .7), rgba(255, 255, 255, 0) 70%, rgba(255, 255, 255, 0));
                transform: scale(1.1);
                filter: blur(15px);
                z-index: -1;
            }
        }
        /* --- 手机号预约 --- */
        .ios {
            @include channel;
            display: block;
            width: pxTorem(22px);
            height: pxTorem(27px);
            background-position: 0 0;
        }
        .google {
            @include channel;
            display: block;
            width: pxTorem(25px);
            height: pxTorem(27px);
            background-position: pxTorem(-22px) 0;
        }
        // 渠道选择
        .sel-channel-box {
            display: flex;
            justify-content: space-between;
            margin-bottom: pxTorem(30px);
            
            // checkbox样式
            .sel-checkbox {
                width: pxTorem(18px);
                height: pxTorem(18px);
                border-radius: 50%;
                border: 2px solid #a6a6a6;
                box-sizing: border-box;
                cursor: pointer;
                margin-right: pxTorem(15px);

                &.active {
                    background-color: #fff000;
                }
            }
            @mixin selbox {
                display: flex;
                align-items: center;
            }
            .sel-ios-box {
                @include selbox;
            }
            .sel-google-box {
                @include selbox;
            }
            .sel-text {
                color: #fff;
                font-family: 'Noto Sans KR', sans-serif;
                font-size: pxTorem(24px);
                margin-left: pxTorem(15px);
            }
        }
        // 手机号码输入
        .phone-box {
            width: 100%;
            height: pxTorem(40px);
            background-color: rgba(77, 76, 74, .8);
            position: relative;
            display: flex;
            margin-bottom: pxTorem(38px);
            
            &::after {
                content: "";
                display: block;
                width: 100%;
                height: 2px;
                background: linear-gradient(to right, #fff 70%, #fff452);
                position: absolute;
                top: 100%;
                left: 0;
            }

            .phone-pre-num {
                width: pxTorem(100px);
                height: 100%;
                font-family: 'Noto Sans KR', sans-serif;
                color: #fff;
                font-size: pxTorem(20px);
                line-height: pxTorem(40px);
                text-align: center;
            }
            .phone-content {
                flex: 1;
                font-size: 0;

                .phone-content-input {
                    outline: none;
                    border: 0px;
                    width: 100%;
                    height: 100%;
                    font-size: pxTorem(20px);
                    box-sizing: border-box;
                    background: transparent;
                    color: #fff;
                    font-family: 'Noto Sans KR', sans-serif;
                }
            }
        }
        /* --- 引导去申请邮件 --- */
        .toemail_tip {
            color: #fff;
            font-family: 'Noto Sans KR', sans-serif;
            font-size: pxTorem(46px);
            text-align: center;
            margin-bottom: pxTorem(20px);
            font-weight: bolder;
            text-shadow: 1px 3px 5px #000;
            letter-spacing: 8px;
        }
        .toemail_btn {
            display: block;
            width: 100%;
            margin-bottom: pxTorem(25px);
            cursor: pointer;
            transition: all .3s ease-in-out;
        }
        /* --- 申请邮件 --- */
        .email-cover {
            width: 100%;
            padding: 0 pxTorem(30px);
            box-sizing: border-box;

            .email-title {
                display: flex;
                align-items: center;
                margin-bottom: pxTorem(30px);
                
                .email_icon {
                    width: pxTorem(40px);
                    margin-right: pxTorem(15px);
                }
                .email_tip {
                    color: #fff;
                    font-family: 'Noto Sans KR', sans-serif;
                    font-size: pxTorem(25px);
                    text-shadow: 1px 3px 5px #000;
                }
            }
            .email-label {
                color: #fff;
                font-family: 'Noto Sans KR', sans-serif;
                font-size: pxTorem(21px);
                margin-bottom: pxTorem(10px);
            }
            .email-content {
                width: 100%;
                height: pxTorem(40px);
                font-size: 0;
                margin-bottom: pxTorem(20px);
                
                .email-input {
                    outline: none;
                    border: 0px;
                    width: 100%;
                    height: 100%;
                    font-size: pxTorem(12px);
                    box-sizing: border-box;
                    padding: 0 pxTorem(15px);
                    background: rgba(255, 255, 255, .1);
                    color: #fff;
                    font-family: 'Noto Sans KR', sans-serif;
                    letter-spacing: 0.1em;
                    @include placeholderColor(rgb(223, 223, 223));
                }

                &::after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 2px;
                    background: linear-gradient(to right, #fff 70%, #fff452);
                }
            }
            .code-wrap {
                width: 100%;
                height: pxTorem(40px);
                font-size: 0;
                margin-bottom: pxTorem(20px);
                display: flex;

                .code-content {
                    flex: 1;
                    margin-right: pxTorem(26px);
                    
                    .code-input {
                        outline: none;
                        border: 0px;
                        width: 100%;
                        height: calc(100% - 2px);
                        font-size: pxTorem(12px);
                        box-sizing: border-box;
                        padding: 0 pxTorem(15px);
                        background: rgba(255, 255, 255, .1);
                        color: #fff;
                        font-family: 'Noto Sans KR', sans-serif;
                        letter-spacing: 0.1em;
                        @include placeholderColor(rgb(223, 223, 223));
                    }

                    &::after {
                        content: "";
                        display: block;
                        width: 100%;
                        height: 2px;
                        background: linear-gradient(to right, #fff 70%, #fff452);
                    }
                }
                .code-btn {
                    width: pxTorem(214px);
                    height: 100%;
                    box-sizing: border-box;
                    border: 1px solid #ffc600;
                    background: linear-gradient(to right, #deb827, #b7772d);
                    color: #fff;
                    font-family: 'Noto Sans KR', sans-serif;
                    font-size: pxTorem(20px);
                    text-align: center;
                    letter-spacing: 2px;
                    line-height: pxTorem(40px);
                    text-shadow: 1px 1px 3px #000;
                    cursor: pointer;

                    span {

                    }
                }
            }
            .email-btn {
                width: 100%;
                height: pxTorem(40px);
                box-sizing: border-box;
                border: 1px solid #ffce00;
                background: rgba(217, 132, 62, .25);
                color: #fff;
                font-size: pxTorem(21px);
                line-height: pxTorem(40px);
                text-align: center;
                letter-spacing: pxTorem(45px);
                text-indent: pxTorem(45px);
                cursor: pointer;
                margin-bottom: pxTorem(40px);
                @include userSelect;
            }
            .email-tip {
                font-size: pxTorem(14px);
                color: #fff;
                font-family: 'Noto Sans KR', sans-serif;
                letter-spacing: pxTorem(2px);
                line-height: 2;

                a {
                    color: #deb827;
                }

                .email-tip--indent {
                    text-indent: 1em;
                }

                /* &::after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 2px;
                    background: linear-gradient(to right, rgba(255, 255, 255, .1), rgba(255, 255, 255, .3) 50%, rgba(255, 255, 255, .1));
                    margin: pxTorem(20px) 0 pxTorem(30px);
                } */
            }
        }
        /*  --- sns分享 --- */
        .share-sns-cover {
            width: 100%;
            padding: 0 pxTorem(30px);
            box-sizing: border-box;

            .share-title {
                display: flex;
                align-items: center;
                margin-bottom: pxTorem(30px);
                
                .share-icon {
                    width: pxTorem(40px);
                    margin-right: pxTorem(15px);
                }
                .share-tip {
                    color: #fff;
                    font-family: 'Noto Sans KR', sans-serif;
                    font-size: pxTorem(25px);
                    text-shadow: 1px 3px 5px #000;
                }
            }
            .share-text {
                color: #fff;
                font-family: 'Noto Sans KR', sans-serif;
                font-size: pxTorem(17px);
                letter-spacing: pxTorem(2px);

                &::after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 2px;
                    background: linear-gradient(to right, rgba(186, 157, 40, .3), #ba9d28 50%, rgba(186, 157, 40, .3));
                    margin: pxTorem(16px) 0;
                }

                a {
                    color: #ffc600;
                }

                p:not(:last-child) {
                    margin-bottom: pxTorem(10px);
                }
            }
            .sns-title {
                @extend .share-title;
                margin-bottom: pxTorem(10px);
            }
            .sns-btn-box {
                display: flex;
                width: 100%;
                justify-content: space-between;
                margin-bottom: pxTorem(20px);
                
                .sns-btn {
                    flex: 1;
                    cursor: pointer;
                    &:not(:last-child) {
                        margin-right: pxTorem(5px);
                    }
                    .sns-img {
                        width: 100%;
                    }
                }
            }
            .share-text--bottom {
                @extend .share-text;
                &::after {
                    /* background: linear-gradient(to right, rgba(255, 255, 255, .1), rgba(255, 255, 255, .3) 50%, rgba(255, 255, 255, .1));
                    margin: pxTorem(16px) 0 pxTorem(20px); */
                    height: 0;
                }
            }
        }
        /* --- 条款详细 --- */
        .terms-cover {
            width: 100%;
            padding: 0 pxTorem(30px);
            box-sizing: border-box;
            
            .terms-title {
                display: flex;
                align-items: center;
                margin-bottom: pxTorem(20px);
                
                .terms-icon {
                    width: pxTorem(40px);
                    margin-right: pxTorem(15px);
                }
                .terms-tip {
                    color: #fff;
                    font-family: 'Noto Sans KR', sans-serif;
                    font-size: pxTorem(25px);
                    text-shadow: 1px 3px 5px #000;
                }
            }
            .terms-detail {
                font-size: pxTorem(17px);
                color: #fff;
                font-family: 'Noto Sans KR', sans-serif;
                line-height: 1.8;
                text-shadow: 1px 2px 5px #000;

                &::after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 2px;
                    background: linear-gradient(to right, rgba(255, 255, 255, .1), rgba(255, 255, 255, .3) 50%, rgba(255, 255, 255, .1));
                    margin: pxTorem(20px) 0 pxTorem(30px);
                }

                .terms-a {
                    color: #fff000;
                }
            }
        }
        // 勾选文档
        .terms-box {
            display: flex;
            align-items: center;
            margin-bottom: pxTorem(25px);

            .terms-checkbox {
                width: pxTorem(18px);
                height: pxTorem(18px);
                box-sizing: border-box;
                border: 2px solid #fff;
                cursor: pointer;
                flex-shrink: 0;
                margin-right: pxTorem(10px);

                &.active {
                    background: #fff000;
                    border-color: #fff000;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    
                    &::after {
                        content: "\e63b";
                        color: #000;
                        font-size: pxTorem(16px);
                        margin-top: 1px;    // border 2px
                    }
                }
                &.disable {
                    opacity: 0.3;
                }
            }
            .terms-text {
                color: #fff;
                font-family: 'Noto Sans KR', sans-serif;
                font-size: pxTorem(21px);

                span {
                    // background: linear-gradient(to right, #fff 75%, #fff000);
                    // background-clip: text;
                    // -webkit-text-fill-color: transparent;
                    margin-right: pxTorem(18px);

                    &.disable {
                        opacity: 0.3;
                    }
                }
                a {
                    color: #fff000;
                    text-decoration: underline;
                }
            }
        }
        // cbt btn
        .cbt-btn-wrap {
            width: 100%;
            min-height: pxTorem(47px);
            position: relative;
            margin-bottom: pxTorem(20px);
            cursor: pointer;

            .cbt-btn-img {
                display: block;
                width: 100%;
                opacity: 1;
                transition: opacity .3s ease-in-out;
            }

            &::after {
                content: "";
                display: block;
                width: 100%;
                height: 100%;
                background: url("../../assets/images/home/pre/cbt_btn_active.png") no-repeat;
                background-size: 100% 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
                opacity: 0;
                transition: opacity .3s ease-in-out;
            }

            &.active {
                .cbt-btn-img {
                    opacity: 0;
                }
                &::after {
                    opacity: .3;
                }
            }
        }
        // cbt top
        .cbt-tip {
            color: #fff;
            font-family: 'Noto Sans KR', sans-serif;
            font-size: pxTorem(21px);
            transition: all .3s ease-in-out;

            .cbt-tip-mark {
                background: transparent;
                color: #fff000;
                text-decoration: underline;
            }

            &.cbt-tip--toemail {
                margin-top: pxTorem(60px);
                text-align: center;
                display: flex;
                justify-content: space-around;
                
                .pre-ios, .pre-google {
                    width: pxTorem(200px);

                    img {
                        display: block;
                        width: 100%;
                    }

                    &.pre-ios {
                        position: relative;
                        // pointer-events: none;

                        /* &::after {
                            content: "";
                            display: block;
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            background: rgba(0, 0, 0, .7);
                            border-radius: 8px;
                            z-index: 1;
                        }
                        &::before {
                            content: "준비 중";
                            display: block;
                            position: absolute;
                            color: #fff;
                            font-family: 'Noto Sans KR', sans-serif;
                            font-weight: 700;
                            font-size: pxTorem(14px);
                            z-index: 2;
                            left: 50%;
                            top: 2%;
                            transform: translateX(-50%);
                        } */
                    }
                }
            }
        }
    }
    .toemail-mask {
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 50%;
        background: linear-gradient(to bottom, rgba(18, 19, 19, 0), #121313 60%, #121313);
        bottom: 0;
        left: 0;
        opacity: 0;
        transition: all .3s ease-in-out;

        &.show {
            opacity: 1;
        }
    }

    .role-enter-active{
        transition: all .5s ease-in-out;
        // transition-delay: 0.5s;
    }
    .role-leave-active {
    }
    .role-enter, .role-leave-to {
        opacity: 0;
    }

    .switch-enter-active{
        transition: all .5s ease-in-out;
    }
    .switch-leave-active {
        // transition: all .3s ease-in-out;
    }
    .switch-enter, .switch-leave-to {
        opacity: 0;
        transform: translateY(30%);
    }

    .pretip-enter-active, .pretip-leave-active{
        transition: all .5s ease-in-out;
    }
    .pretip-enter, .pretip-leave-to {
        opacity: 0;
    }
}
</style>
